export const PRODUCT_NAME_MAX_LENGTH = 80

export function normalizeProductName(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const cleaned = value.replace(/\s+/g, ' ').trim()
  if (!cleaned || cleaned.length > PRODUCT_NAME_MAX_LENGTH) return null
  return cleaned
}
